import { subDays } from 'date-fns';
import { seededRandom } from 'lib_ts/classes/math.utilities';
import { HitterProfilePeriod } from 'lib_ts/enums/hitters.enums';
import { PitchType } from 'lib_ts/enums/pitches.enums';
import { TrackingDevice } from 'lib_ts/enums/training.enums';
import { ISessionHit } from 'lib_ts/interfaces/session-hits/i-session-hit';

const DEMO_MACHINE_ID = 'demo-machine';

/**
 * Last1Month buckets the Total BP chart by day, which gives the densest chart
 * of the available periods. The hit dates below have to stay inside this window
 * or the charts will filter them all out.
 */
export const DEMO_HITS_PERIOD = HitterProfilePeriod.Last1Month;

/** a couple of days more than the period, so every bucket in the chart is covered */
const DEMO_HITS_DAYS = 32;

const DEMO_HIT_PITCH_TYPES = [
  PitchType.FourSeamFastball,
  PitchType.Slider,
  PitchType.Curveball,
  PitchType.ChangeUp,
  PitchType.Sinker,
  PitchType.Cutter,
];

export const buildDemoSessionHits = (): ISessionHit[] => {
  const random = seededRandom(7);

  const hits: ISessionHit[] = [];

  for (let daysAgo = 0; daysAgo < DEMO_HITS_DAYS; daysAgo += 1) {
    // occasional rest days keep the area chart from looking flat
    const dailyHits = random() < 0.25 ? 0 : 4 + Math.round(random() * 12);

    for (let i = 0; i < dailyHits; i += 1) {
      const created = subDays(new Date(), daysAgo).toISOString();
      const suffix = `${daysAgo}-${i}`;

      hits.push({
        _id: `demo-hit-${suffix}`,
        _created: created,
        _changed: created,
        // a handful of excluded hits so batted-ball totals differ from BP totals
        avg_excluded: random() < 0.08,
        tracking_device: TrackingDevice.TrajektVision,
        fire: {
          _id: `demo-fire-${suffix}`,
          machineID: DEMO_MACHINE_ID,
          session: `demo-session-${daysAgo}`,
        },
        pitch: {
          _id: `demo-pitch-${suffix}`,
          type: DEMO_HIT_PITCH_TYPES[
            Math.floor(random() * DEMO_HIT_PITCH_TYPES.length)
          ],
          name: 'Demo Pitch',
        },
        hit: {
          // spread across the weak / medium / hard contact thresholds
          exitMPH: 62 + random() * 45,
        },
      });
    }
  }

  return hits;
};
